import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import logo1 from "../assets/image1.jpg";
import Navbar from "./Navbar";
import testominialBG from "../assets/international.jpg";
import Footer from "./Footer";
import { getDatabase, ref, onValue, push, set } from "firebase/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faCheckCircle,
  faEnvelope,
  faFilePdf,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { jsPDF } from "jspdf";
import { getStorage, getDownloadURL } from "firebase/storage";
import html2canvas from "html2canvas";
import SEO from "./SEO";

const EnquiryForm = ({ onClose, tour }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    travellers: "",
    date: "",
    destination: tour?.destination || "",
    tourName: tour?.name || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const database = getDatabase();
      const enquiryRef = ref(database, `enquiry/${formData.mobile}`);
      await set(enquiryRef, {
        ...formData,
        status: "pending",
        timestamp: new Date().toISOString(),
      });
      alert("Enquiry submitted successfully!");
      onClose();
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to submit enquiry. Please try again.");
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="modal-header">
          <h2>Send us a Query</h2>
          <p>
            Ready to venture out into the world? Fill the form below and start
            your brand new journey with us
          </p>
        </div>

        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="form-group">
            <label>Name*</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email*</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile*</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>No of travellers*</label>
            <input
              type="number"
              name="travellers"
              value={formData.travellers}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date*</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Destination*</label>
              <input
                type="text"
                name="destination"
                value={formData.destination}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const TourDetailsModal = ({ tour, onClose }) => {
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);



const generatePDF = async () => {
  if (!tour) return;

  const PAGE_WIDTH = 210; // A4 width in mm
  const LEFT_MARGIN = 20;
  const RIGHT_MARGIN = 20;
  const CONTENT_WIDTH = PAGE_WIDTH - LEFT_MARGIN - RIGHT_MARGIN;
  const TOP_MARGIN = 20;
  const BOTTOM_MARGIN = 275;

  function wrapTextByWords(text, wordsPerLine = 9) {
    if (!text) return [];
    const words = text.split(/\s+/);
    let lines = [];
    for (let i = 0; i < words.length; i += wordsPerLine) {
      lines.push(words.slice(i, i + wordsPerLine).join(" "));
    }
    return lines;
  }

  const ensureSafeY = (requiredSpace = 10) => {
    if (yPosition + requiredSpace > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    }
  };

  const loadPriceImage = async (imagePath) => {
    if (!imagePath) return null;

    try {
      const storage = getStorage();
      const downloadUrl = await getDownloadURL(ref(storage, imagePath));
      const response = await fetch(downloadUrl);
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error loading price image:", error);
      return null;
    }
  };

  // Load logo
  const img = new Image();
  img.src = logo1;
  await new Promise((resolve) => (img.onload = resolve));

  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  const dataURL = canvas.toDataURL("image1/jpg");

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  let yPosition = 10;

  // LOGO
  const logoWidth = 200;
  const logoHeight = 100;
  const centerX = 105 - logoWidth / 2;
  doc.addImage(dataURL, "PNG", centerX, yPosition, logoWidth, logoHeight);
  yPosition += logoHeight + 5;


  // PACKAGE TITLE
  doc.setFontSize(16);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("TOUR PACKAGE DETAILS", 105, yPosition, { align: "center" });
  yPosition += 15;

  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.5);
  doc.line(LEFT_MARGIN, yPosition, PAGE_WIDTH - RIGHT_MARGIN, yPosition);
  yPosition += 10;

  // PACKAGE DETAILS
  ensureSafeY(40);
  doc.setFontSize(14);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text(tour.name.toUpperCase(), LEFT_MARGIN, yPosition);
  yPosition += 10;

  doc.setFontSize(12);
  doc.setTextColor(80, 80, 80);
  doc.setFont("helvetica", "normal");
  doc.text(`Destination: ${tour.destination}`, LEFT_MARGIN, yPosition);
  yPosition += 7;
  doc.text(`Duration: ${tour.duration}`, LEFT_MARGIN, yPosition);
  yPosition += 7;

  // PRICES SECTION - FIXED OVERLAP ISSUE
  doc.setFontSize(12);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("PRICE DETAILS", LEFT_MARGIN, yPosition);
  yPosition += 7;

  doc.setFontSize(10); // Reduced font size for price details
  doc.setFont("helvetica", "normal");

  if (tour.priceValues && typeof tour.priceValues === 'object' && Object.keys(tour.priceValues).length > 0) {
    doc.setFillColor(241, 243, 245);
    doc.rect(LEFT_MARGIN - 5, yPosition, CONTENT_WIDTH + 10, 8, "F");
    
    doc.setFontSize(10);
    doc.setTextColor(30, 58, 138);
    doc.text("Price Breakdown", LEFT_MARGIN, yPosition + 6);
    yPosition += 15;

    Object.entries(tour.priceValues).forEach(([priceType, priceValue]) => {
      ensureSafeY(10);
      
      // Clean up the price value for better formatting
      let formattedPrice = priceValue;
      if (typeof priceValue === 'string') {
        // Replace single quotes with proper formatting
        formattedPrice = priceValue.replace(/'/g, '').replace(/Inr\./gi, 'INR');
      }
      
      // Use jsPDF's text wrapping to prevent overflow with smaller max width
      const priceText = `${priceType}: ${formattedPrice}`;
      const priceLines = doc.splitTextToSize(priceText, CONTENT_WIDTH - 10);
      
      doc.text(priceLines, LEFT_MARGIN, yPosition);
      yPosition += priceLines.length * 5; // Reduced line height for price items
      
      if (yPosition < BOTTOM_MARGIN - 10) {
        doc.setDrawColor(220, 220, 220);
        doc.setLineWidth(0.2);
        doc.line(LEFT_MARGIN + 5, yPosition, PAGE_WIDTH - RIGHT_MARGIN, yPosition);
        yPosition += 5;
      }
    });
    
    if (tour.totalPrice) {
      ensureSafeY(15);
      doc.setFont("helvetica", "bold");
      
      // Clean up total price formatting
      let formattedTotal = tour.totalPrice;
      if (typeof tour.totalPrice === 'string') {
        formattedTotal = tour.totalPrice.replace(/'/g, '');
      }
      
      const totalPriceText = `Total Package Price: ${formattedTotal}`;
      const totalPriceLines = doc.splitTextToSize(totalPriceText, CONTENT_WIDTH);
      
      doc.text(totalPriceLines, LEFT_MARGIN, yPosition);
      yPosition += totalPriceLines.length * 7;
    }
  } else {
    doc.text("No pricing information available", LEFT_MARGIN, yPosition);
    yPosition += 7;
  }

  yPosition += 10;

  // ALWAYS START DESCRIPTION ON A NEW PAGE
  doc.addPage();
  yPosition = TOP_MARGIN;

  // DESCRIPTION
  doc.setFontSize(14);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("DESCRIPTION", LEFT_MARGIN, yPosition);
  yPosition += 10;

  doc.setFontSize(12);
  doc.setTextColor(50, 50, 50);
  
  // Use jsPDF's built-in text wrapping for description
  const descriptionText = tour.description || "No description available";
  const descriptionLines = doc.splitTextToSize(descriptionText, CONTENT_WIDTH);
  
  ensureSafeY(descriptionLines.length * 6 + 15);
  doc.text(descriptionLines, LEFT_MARGIN, yPosition);
  yPosition += descriptionLines.length * 6 + 15;

  // ITINERARY
  if (
    tour.itinerary &&
    typeof tour.itinerary === "object" &&
    Object.keys(tour.itinerary).length > 0
  ) {
    doc.addPage();
    yPosition = TOP_MARGIN;

    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
    yPosition += 15;

    Object.entries(tour.itinerary).forEach(([dayTitle, description]) => {
      // Use jsPDF's built-in text wrapping for itinerary
      const descLines = doc.splitTextToSize(description, CONTENT_WIDTH);
      ensureSafeY(10 + descLines.length * 6 + 10);

      doc.setFillColor(241, 243, 245);
      doc.rect(LEFT_MARGIN - 5, yPosition, CONTENT_WIDTH + 10, 8, "F");
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.text(dayTitle, LEFT_MARGIN, yPosition + 6);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(50, 50, 50);
      doc.text(descLines, LEFT_MARGIN, yPosition + 5);
      yPosition += descLines.length * 6 + 10;
    });
  }

  // INCLUSIONS
  doc.addPage();
  yPosition = TOP_MARGIN;
  doc.setFontSize(16);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("INCLUSIONS", LEFT_MARGIN, yPosition);
  yPosition += 10;
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  if (tour.includes && typeof tour.includes === "object") {
    Object.values(tour.includes).forEach((item) => {
      // Use jsPDF's built-in text wrapping for inclusions
      const lines = doc.splitTextToSize(item, CONTENT_WIDTH - 10);
      ensureSafeY(lines.length * 6 + 5);
      
      // Handle bullet points with wrapped text
      doc.text("•", LEFT_MARGIN, yPosition);
      doc.text(lines, LEFT_MARGIN + 5, yPosition);
      yPosition += lines.length * 6;
    });
  } else {
    doc.text("No inclusions listed.", LEFT_MARGIN + 5, yPosition);
    yPosition += 7;
  }

  yPosition += 10;

  // EXCLUSIONS
  doc.setFontSize(16);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("EXCLUSIONS", LEFT_MARGIN, yPosition);
  yPosition += 10;
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  if (tour.excludes && typeof tour.excludes === "object") {
    Object.values(tour.excludes).forEach((item) => {
      // Use jsPDF's built-in text wrapping for exclusions
      const lines = doc.splitTextToSize(item, CONTENT_WIDTH - 10);
      ensureSafeY(lines.length * 6 + 5);
      
      // Handle bullet points with wrapped text
      doc.text("•", LEFT_MARGIN, yPosition);
      doc.text(lines, LEFT_MARGIN + 5, yPosition);
      yPosition += lines.length * 6;
    });
  } else {
    doc.text("No exclusions listed.", LEFT_MARGIN + 5, yPosition);
    yPosition += 7;
  }

  // TERMS & CONDITIONS
  if (tour.termsAndConditions) {
    doc.addPage();
    yPosition = TOP_MARGIN;
    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("TERMS & CONDITIONS", 105, yPosition, { align: "center" });
    yPosition += 15;
    doc.setFontSize(11);
    doc.setTextColor(80, 80, 80);
    doc.setFont("helvetica", "normal");

    // Use jsPDF's built-in text wrapping for terms
    const termsLines = doc.splitTextToSize(tour.termsAndConditions, CONTENT_WIDTH);
    ensureSafeY(termsLines.length * 5 + 10);
    doc.text(termsLines, LEFT_MARGIN, yPosition);
  }

  // FOOTER
  const pageCount = doc.internal.getNumberOfPages();
  const footerY = 287;
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(LEFT_MARGIN, footerY - 5, PAGE_WIDTH - RIGHT_MARGIN, footerY - 5);
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Page ${i} of ${pageCount}`, 105, footerY, { align: "center" });
    doc.text("Pearl Tours & Travels", LEFT_MARGIN, footerY);
    doc.text(new Date().toLocaleDateString(), PAGE_WIDTH - RIGHT_MARGIN, footerY, {
      align: "right",
    });
  }

  doc.save(`${tour.name.replace(/\s+/g, "_")}_package_details.pdf`);
};



  if (!tour) return null;

  return (
    <>
      <div
        className="modal-overlay"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="modal-container">
          <button className="modal-close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className="modal-header">
            <h2>{tour.name}</h2>
            <div className="modal-subheader">
              <span className="modal-location">
                <i className="fas fa-map-marker-alt"></i> {tour.destination}
              </span>
              <span className="modal-duration">
                <i className="far fa-clock"></i> {tour.duration}
              </span>
              <span className="modal-rating">
                {"★".repeat(tour.rating || 5)}
                {"☆".repeat(5 - (tour.rating || 5))} ({tour.rating || 5}.0)
              </span>
            </div>
          </div>

          <div className="modal-image-gallery">
            <div className="main-image">
              <img
                src={
                  tour.images?.[0] ||
                  "https://via.placeholder.com/800x500?text=No+Image"
                }
                alt={tour.name}
                onClick={() =>
                  tour.images?.[0] && setSelectedImage(tour.images[0])
                }
              />
            </div>

            <div className="thumbnail-container">
              {(tour.images || []).slice(0, 4).map((img, index) => (
                <div
                  key={index}
                  className="thumbnail"
                  onClick={() => setSelectedImage(img)}
                >
                  <img src={img} alt={`${tour.name} ${index + 1}`} />
                </div>
              ))}
            </div>

            {selectedImage && (
              <div
                className="image-popup-overlay"
                onClick={() => setSelectedImage(null)}
              >
                <div
                  className="image-popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="popup-close-btn"
                    onClick={() => setSelectedImage(null)}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>

                  <img
                    src={selectedImage}
                    alt="Enlarged view"
                    className="popup-image"
                  />

                  {tour.images?.length > 1 && (
                    <div className="image-nav">
                      <button
                        className="nav-btn prev-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          const currentIndex =
                            tour.images.indexOf(selectedImage);
                          const prevIndex =
                            (currentIndex - 1 + tour.images.length) %
                            tour.images.length;
                          setSelectedImage(tour.images[prevIndex]);
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </button>

                      <button
                        className="nav-btn next-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          const currentIndex =
                            tour.images.indexOf(selectedImage);
                          const nextIndex =
                            (currentIndex + 1) % tour.images.length;
                          setSelectedImage(tour.images[nextIndex]);
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="modal-content">
            <div className="modal-price-section">
              <div className="price-box">
                <span className="itinerary">
                  Description : <br />
                  {tour.description}
                </span>
                <div className="modal-pricing-details">
                  <span className="price-label">All Pricing Details:</span>
                  <div className="modal-price-list">
                    {tour.priceValues && Object.entries(tour.priceValues).map(([priceType, priceValue]) => (
                      <div key={priceType} className="modal-price-item">
                        <span className="modal-price-type">{priceType}:</span>
                        <span className="modal-price-amount">
                          ₹{(priceValue || 0).toLocaleString('en-IN')}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <button
                  className="enquiry-now-btn"
                  onClick={() => setShowEnquiryForm(true)}
                >
                  <FontAwesomeIcon icon={faEnvelope} /> Enquiry Now
                </button>

                <button className="download-pdf-btn" onClick={generatePDF}>
                  <FontAwesomeIcon icon={faFilePdf} /> Download PDF
                </button>
              </div>
            </div>

            <div className="modal-details-section">
              <h3>Package Highlights</h3>
              <ul className="highlights-list">
                {(tour.highlights || []).map((item, index) => (
                  <li key={index}>
                    <FontAwesomeIcon icon={faCheckCircle} /> {item}
                  </li>
                ))}
              </ul>

              <h3>Detailed Itinerary</h3>
              <div className="itinerary">
                {tour.itinerary && typeof tour.itinerary === "object" ? (
                  Object.entries(tour.itinerary).map(
                    ([dayTitle, description], index) => (
                      <div key={index} className="day-plan">
                        <h4>{dayTitle}</h4>
                        <p>{description}</p>
                      </div>
                    )
                  )
                ) : (
                  <p>No detailed itinerary available.</p>
                )}
              </div>

              <h3>Inclusions</h3>
              <ul className="inclusions-list">
                {tour.includes && typeof tour.includes === "object" ? (
                  Object.values(tour.includes).map((item, index) => (
                    <li key={index}>
                      <FontAwesomeIcon icon={faCheck} /> {item}
                    </li>
                  ))
                ) : (
                  <li>No inclusions listed.</li>
                )}
              </ul>

              <h3>Exclusions</h3>
              <ul className="exclusions-list">
                {tour.excludes && typeof tour.excludes === "object" ? (
                  Object.values(tour.excludes).map((item, index) => (
                    <li key={index}>
                      <FontAwesomeIcon icon={faTimes} /> {item}
                    </li>
                  ))
                ) : (
                  <li>No exclusions listed.</li>
                )}
              </ul>

              {tour.termsAndConditions && (
                <>
                  <h3>Terms & Conditions</h3>
                  <p className="terms">{tour.termsAndConditions}</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {showEnquiryForm && (
        <EnquiryForm onClose={() => setShowEnquiryForm(false)} tour={tour} />
      )}
    </>
  );
};

const TourCard = ({ tour, onClick }) => (
  <div className="card">
    <div className="card-image-container">
      {tour.bestSelling && <span className="badge">Best Seller</span>}
      <img
        src={
          tour.images?.[0] ||
          "https://via.placeholder.com/300x200?text=No+Image"
        }
        alt={tour.title}
        className="card-image"
      />
      <div className="location-tag">{tour.destination}</div>
    </div>
    <div className="card-content">
      <div className="card-header">
        <h2 className="card-title">{tour.name}</h2>
        <div className="card-duration">
          <i className="far fa-clock"></i> {tour.duration}
        </div>
      </div>
      <div className="card-rating-price">
        <div className="card-rating">
          {"★".repeat(tour.rating || 5)}
          {"☆".repeat(5 - (tour.rating || 5))}
          <span>({tour.rating || 5}.0)</span>
        </div>
        <div className="card-price">
  <span className="from">Starting from</span>
  <span className="price-amount">
    ₹{(
      tour.priceValues?.[Object.keys(tour.priceValues)?.[0]] || 0
    ).toLocaleString('en-IN')}
  </span>
</div>
      </div>
      <div className="card-highlights">
        <h4>Highlights:</h4>
        <p>{tour.description?.split(" ").slice(0, 15).join(" ")}...</p>
      </div>
      <div className="card-footer">
        <button className="view-btn" onClick={onClick}>
          <i className="far fa-eye"></i> View Details
        </button>
      </div>
    </div>
  </div>
);

export default function InternationalTourPackages() {
  const [priceRange, setPriceRange] = useState([0, 150000]);
  const [visibleCount, setVisibleCount] = useState(3);
  const [showFlights, setShowFlights] = useState(true);
  const [showDestinations, setShowDestinations] = useState(true);
  const [selectedDestinations, setSelectedDestinations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [allPackages, setAllPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTour, setSelectedTour] = useState(null);

  useEffect(() => {
    const database = getDatabase();
    const packagesRef = ref(database, "packages");

    const unsubscribe = onValue(packagesRef, (snapshot) => {
      const data = snapshot.val();
      const packagesArray = [];

      Object.keys(data).forEach((country) => {
        Object.keys(data[country]).forEach((packageName) => {
          const pkg = data[country][packageName];
          if (pkg.type?.toLowerCase() === "domestic") {
            const randomPriceText = 
              pkg.priceValues?.[Math.floor(Math.random() * pkg.priceValues.length)] || "0";
            
            const priceValue = randomPriceText.match(/\d+/g)?.[0] || "0";

            packagesArray.push({
              id: `${country}-${packageName}`,
              ...pkg,
              displayPrice: parseInt(priceValue),
              displayPriceText: randomPriceText,
            });
          }
        });
      });

      setAllPackages(packagesArray);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const filteredPackages = allPackages.filter((pkg) => {
    const priceMatch = pkg.displayPrice >= priceRange[0] && pkg.displayPrice <= priceRange[1];
    const destinationMatch =
      selectedDestinations.length === 0 ||
      selectedDestinations.includes(pkg.destination);
    const searchMatch =
      (pkg.name?.toLowerCase().includes(searchQuery.toLowerCase()) ?? false) ||
      (pkg.destination?.toLowerCase().includes(searchQuery.toLowerCase()) ??
        false) ||
      (pkg.highlights?.some((highlight) =>
        highlight?.toLowerCase().includes(searchQuery.toLowerCase())
      ) ??
        false);

    return priceMatch && destinationMatch && searchMatch;
  });

  const displayedPackages = filteredPackages.slice(0, visibleCount);

  const loadMorePackages = () => {
    setVisibleCount((prev) => Math.min(prev + 3, filteredPackages.length));
  };

  const showLessPackages = () => {
    setVisibleCount(3);
  };

  const handleDestinationChange = (destination) => {
    setSelectedDestinations((prev) =>
      prev.includes(destination)
        ? prev.filter((d) => d !== destination)
        : [...prev, destination]
    );
  };

  const resetFilters = () => {
    setPriceRange([0, 150000]);
    setSelectedDestinations([]);
    setSearchQuery("");
  };

  const destinations = Array.from(
    new Set(allPackages.map((pkg) => pkg.destination))
  ).filter((dest) => dest);

  return (
    <>

        <SEO
        title="Domestic Tours | Pearl Tours & Travels"
        description="Discover India with our exclusive domestic tour packages to Rajasthan, Kerala, Himachal, and more."
        keywords="domestic tours, India trips, Rajasthan travel, Kerala holiday, Himachal tours, Indian destinations"
      />
      <Navbar />
      <style jsx>{`
        :root {
          --primary: #64192e;
          --primary-dark: #64192e;
          --secondary: #f87a9eff;
          --dark: #2f3542;
          --light: #f1f2f6;
          --gray: #a4b0be;
          --white: #ffffff;
          --shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          --transition: all 0.3s ease;
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: "Poppins", sans-serif;
        }

        .container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        .title {
          font-size: 2.5rem;
          color: var(--dark);
          text-align: center;
          margin-bottom: 1rem;
          background: linear-gradient(to right, var(--primary), var(--secondary));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          position: relative;
          padding-bottom: 1rem;
        }

        .title::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 4px;
          background: linear-gradient(to right, var(--primary), var(--secondary));
          border-radius: 2px;
        }

        .subtitle {
          text-align: center;
          color: var(--gray);
          max-width: 700px;
          margin: 0 auto 3rem;
          font-size: 1.1rem;
          line-height: 1.6;
        }

        .search-container {
          max-width: 800px;
          margin: 0 auto 3rem;
          width: 100%;
        }

        .search-box {
          display: flex;
          border-radius: 50px;
          overflow: hidden;
          box-shadow: var(--shadow);
          background: var(--white);
          transition: var(--transition);
          border: 1px solid rgba(0, 0, 0, 0.1);
        }

        .search-box:hover {
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        .search-box input {
          flex: 1;
          padding: 1.2rem 1.5rem;
          border: none;
          font-size: 1rem;
          background: transparent;
          color: var(--dark);
        }

        .search-box input::placeholder {
          color: var(--gray);
        }

        .search-box input:focus {
          outline: none;
        }

        .search-box button {
          padding: 0 2.5rem;
          background: linear-gradient(135deg, var(--primary), var(--primary-dark));
          color: var(--white);
          border: none;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .search-box button:hover {
          background: linear-gradient(135deg, var(--primary-dark), var(--primary));
        }

        .layout {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .filter-container {
          background: var(--white);
          border-radius: 10px;
          padding: 1.5rem;
          box-shadow: var(--shadow);
          height: fit-content;
          position: sticky;
          top: 1rem;
        }

        .filter-box {
          margin-bottom: 2rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          padding-bottom: 1.5rem;
        }

        .filter-box:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
          cursor: pointer;
          font-weight: 600;
          color: var(--dark);
        }

        .filter-header i {
          transition: var(--transition);
        }

        .filter-header.collapsed i {
          transform: rotate(-90deg);
        }

        .slider-labels {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.5rem;
          font-size: 0.9rem;
          color: var(--gray);
        }

        .range-slider {
          width: 100%;
          margin-bottom: 1rem;
          -webkit-appearance: none;
          height: 6px;
          border-radius: 3px;
          background: var(--light);
          outline: none;
        }

        .range-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: var(--primary);
          cursor: pointer;
          transition: var(--transition);
        }

        .range-slider::-webkit-slider-thumb:hover {
          transform: scale(1.2);
        }

        .price-inputs {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .price-inputs input {
          width: 100%;
          padding: 0.5rem 1rem;
          border: 1px solid var(--light);
          border-radius: 5px;
          font-size: 0.9rem;
        }

        .price-inputs input:focus {
          outline: none;
          border-color: var(--primary);
        }

        .buttons {
          display: flex;
          gap: 1rem;
        }

        .clear-btn,
        .apply-btn {
          flex: 1;
          padding: 0.7rem;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .clear-btn {
          background: var(--light);
          color: var(--dark);
          border: none;
        }

        .clear-btn:hover {
          background: #e0e0e0;
        }

        .apply-btn {
          background: var(--primary);
          color: var(--white);
          border: none;
        }

        .apply-btn:hover {
          background: var(--primary-dark);
        }

        .checkboxes {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }

        .scrollable {
          max-height: 200px;
          overflow-y: auto;
          padding-right: 0.5rem;
        }

        .scrollable::-webkit-scrollbar {
          width: 5px;
        }

        .scrollable::-webkit-scrollbar-track {
          background: var(--light);
        }

        .scrollable::-webkit-scrollbar-thumb {
          background: var(--gray);
          border-radius: 5px;
        }

        .checkbox-item {
          display: flex;
          align-items: center;
          gap: 0.8rem;
        }

        .checkbox-item input {
          width: 18px;
          height: 18px;
          accent-color: var(--primary);
          cursor: pointer;
        }

        .checkbox-item label {
          cursor: pointer;
          font-size: 0.9rem;
          color: var(--dark);
          transition: var(--transition);
        }

        .checkbox-item:hover label {
          color: var(--primary);
        }

        .cards-container {
          width: 100%;
        }

        .cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .card {
          background: var(--white);
          border-radius: 10px;
          overflow: hidden;
          box-shadow: var(--shadow);
          transition: var(--transition);
          position: relative;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        .card-image-container {
          position: relative;
          height: 200px;
          overflow: hidden;
        }

        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: var(--transition);
        }

        .card:hover .card-image {
          transform: scale(1.05);
        }

        .badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: var(--primary);
          color: var(--white);
          padding: 0.3rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          z-index: 1;
        }

        .location-tag {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          background: rgba(0, 0, 0, 0.7);
          color: var(--white);
          padding: 0.3rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.3rem;
          z-index: 1;
        }

        .card-content {
          padding: 1.5rem;
        }

        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 1rem;
        }

        .card-title {
          font-size: 1.2rem;
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-weight: 600;
          flex: 1;
        }

        .card-duration {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          color: var(--gray);
        }

        .card-rating-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
        }

        .card-rating {
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .card-price {
          text-align: right;
        }

        .from {
          display: block;
          font-size: 0.7rem;
          color: var(--gray);
        }

        .price-amount {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--primary);
        }

        .amount {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--primary);
        }

        .per-person {
          display: block;
          font-size: 0.7rem;
          color: var(--gray);
        }

        .card-highlights {
          margin-bottom: 1.5rem;
        }

        .card-highlights h4 {
          font-size: 1rem;
          color: var(--dark);
          margin-bottom: 0.8rem;
        }

        .card-highlights p {
          font-size: 0.9rem;
          color: var(--gray);
          line-height: 1.5;
        }

        .card-footer {
          display: flex;
          gap: 1rem;
        }

        .view-btn {
          flex: 1;
          padding: 0.7rem;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          background: var(--light);
          color: var(--dark);
          border: 1px solid var(--primary);
        }

        .view-btn:hover {
          background: #64192e;
          color: var(--white);
        }

        .load-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 2rem;
        }

        .load-more-btn,
        .show-less-btn {
          padding: 0.8rem 1.5rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          gap: 0.5rem;
          border: none;
        }

        .load-more-btn {
          background: var(--primary);
          color: var(--white);
        }

        .load-more-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
        }

        .show-less-btn {
          background: var(--light);
          color: var(--dark);
        }

        .show-less-btn:hover {
          background: #e0e0e0;
          transform: translateY(-2px);
        }

        .no-results {
          text-align: center;
          padding: 3rem;
          background: var(--white);
          border-radius: 10px;
          box-shadow: var(--shadow);
        }

        .no-results h3 {
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .no-results p {
          color: var(--gray);
          margin-bottom: 1rem;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 300px;
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: var(--primary);
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .tour-container {
          margin: 4rem 0;
          padding: 2rem 0;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
        }

        .tour-container h1 {
          font-size: 2rem;
          color: var(--dark);
          margin-bottom: 1.5rem;
          text-align: center;
        }

        .tour-container h2 {
          font-size: 1.5rem;
          color: var(--dark);
          margin: 2rem 0 1rem;
        }

        .tour-container p {
          color: var(--gray);
          line-height: 1.8;
          margin-bottom: 1rem;
        }

        .tour-container ol,
        .tour-container ul {
          margin-left: 2rem;
          margin-bottom: 2rem;
        }

        .tour-container li {
          margin-bottom: 0.5rem;
          line-height: 1.6;
        }

        .tour-container strong {
          color: var(--dark);
        }

        .testimonial-wrapper {
          display: flex;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          border-radius: 10px;
          overflow: hidden;
          margin: 4rem 0;
          box-shadow: var(--shadow);
        }

        .testimonial-content {
          flex: 1;
          padding: 3rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .section-label {
          color: var(--primary);
          font-weight: 600;
          margin-bottom: 1rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-size: 0.9rem;
        }

        .testimonial-content h2 {
          font-size: 2rem;
          color: var(--dark);
          margin-bottom: 1.5rem;
        }

        .stars {
          color: #ffc107;
          font-size: 1.2rem;
          margin-bottom: 1.5rem;
          letter-spacing: 3px;
        }

        .testimonial-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: var(--dark);
          margin-bottom: 2rem;
          font-style: italic;
          position: relative;
        }

        .testimonial-text::before {
          content: '"';
          font-size: 4rem;
          color: rgba(0, 0, 0, 0.1);
          position: absolute;
          top: -1.5rem;
          left: -1rem;
          font-family: serif;
        }

        .author {
          font-weight: 600;
          color: var(--dark);
        }

        .testimonial-images {
          flex: 1;
          display: flex;
        }

        .img-left,
        .img-right {
          flex: 1;
          object-fit: cover;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 2rem;
          overflow-y: auto;
        }

        .modal-container {
          background: var(--white);
          border-radius: 10px;
          width: 100%;
          max-width: 1000px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
          position: relative;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-close-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          font-size: 1.5rem;
          color: var(--gray);
          cursor: pointer;
          transition: var(--transition);
          z-index: 10;
        }

        .modal-close-btn:hover {
          color: var(--primary);
        }

        .modal-header {
          padding: 2rem 2rem 1rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }

        .modal-header h2 {
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .modal-subheader {
          display: flex;
          gap: 1.5rem;
          flex-wrap: wrap;
          color: var(--gray);
          font-size: 0.9rem;
        }

        .modal-subheader span {
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .modal-image-gallery {
          position: relative;
          margin-bottom: 20px;
          padding: 0 2rem;
          margin-top: 1rem;
        }

        .main-image {
          width: 100%;
          height: 400px;
          border-radius: 8px;
          overflow: hidden;
        }

        .main-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          cursor: pointer;
          transition: transform 0.3s;
        }

        .main-image img:hover {
          transform: scale(1.01);
        }

        .thumbnail-container {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1rem;
          margin-top: 10px;
        }

        .thumbnail {
          height: 80px;
          border-radius: 5px;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.3s;
        }

        .thumbnail:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        .thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .modal-content {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 2rem;
          padding: 2rem;
        }

        .modal-price-section {
          position: sticky;
          top: 1rem;
          height: fit-content;
        }

        .price-box {
          background: var(--light);
          border-radius: 8px;
          padding: 1.5rem;
          text-align: center;
          box-shadow: var(--shadow);
        }

        .price-label {
          display: block;
          font-size: 0.9rem;
          color: #000000;
          margin-bottom: 1rem;
          font-weight: 600;
        }

        .modal-pricing-details {
          margin-bottom: 1.5rem;
        }

        .modal-price-list {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }

        .modal-price-item {
          display: flex;
          justify-content: start;
          align-items: center;
          padding: 0.8rem;
          background: var(--white);
          border-radius: 5px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          transition: var(--transition);
        }

        .modal-price-item:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transform: translateY(-1px);
        }

        .modal-price-type {
          font-size: 0.9rem;
          color: var(--dark);
          font-weight: 500;
        }

        .modal-price-amount {
          font-size: 1rem;
          font-weight: 700;
          color: var(--primary);
        }

        .price-amount {
          font-size: 1rem;
          font-weight: 700;
          color: var(--primary);
          display: block;
          line-height: 1;
        }

        .price-per {
          display: block;
          font-size: 0.8rem;
          color: var(--gray);
          margin-bottom: 1.5rem;
        }

        .enquiry-now-btn {
          width: 100%;
          padding: 0.8rem;
          background: #64192e;
          color: var(--white);
          border: none;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        }

        .enquiry-now-btn:hover {
          background: #ffffffff;
          color: var(--primary);
          border: 1px solid var(--primary);
        }

        .modal-details-section h3 {
          color: var(--dark);
          margin: 1.5rem 0 1rem;
          font-size: 1.2rem;
        }

        .highlights-list,
        .inclusions-list,
        .exclusions-list {
          list-style: none;
          margin-bottom: 1.5rem;
        }

        .highlights-list li,
        .inclusions-list li,
        .exclusions-list li {
          margin-bottom: 0.5rem;
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
        }

        .highlights-list i {
          color: var(--primary);
        }

        .inclusions-list i {
          color: #2ecc71;
        }

        .exclusions-list i {
          color: #e74c3c;
        }

        .day-plan {
          margin-bottom: 1.5rem;
        }

        .day-plan h4 {
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .day-plan p {
          color: var(--gray);
          line-height: 1.6;
        }

        .terms {
          font-size: 0.9rem;
          color: var(--gray);
          line-height: 1.6;
        }

        .enquiry-form {
          padding: 2rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-group label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: var(--dark);
        }

        .form-group input {
          width: 100%;
          padding: 0.8rem;
          border: 1px solid var(--light);
          border-radius: 5px;
          font-size: 1rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }

        .submit-btn {
          width: 100%;
          padding: 1rem;
          background: var(--primary);
          color: white;
          border: none;
          border-radius: 5px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .submit-btn:hover {
          background: var(--primary-dark);
        }

        .image-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.9);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .image-popup-content {
          position: relative;
          max-width: 90%;
          max-height: 90%;
        }

        .popup-image {
          max-width: 100%;
          max-height: 80vh;
          display: block;
          margin: 0 auto;
          border-radius: 8px;
        }

        .popup-close-btn {
          position: absolute;
          top: -40px;
          right: 0;
          background: none;
          border: none;
          color: white;
          font-size: 24px;
          cursor: pointer;
          padding: 5px;
        }

        .image-nav {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          transform: translateY(-50%);
          padding: 0 20px;
        }

        .nav-btn {
          background: rgba(255, 255, 255, 0.3);
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          color: white;
          font-size: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.3s;
        }

        .nav-btn:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        .modal-action-buttons {
          display: flex;
          gap: 1rem;
          margin-top: 1rem;
        }

        .download-pdf-btn {
          width: 100%;
          padding: 0.8rem;
          background: #ffffffff;
          color: #64192e;
          border: 1px solid var(--primary);
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1rem;
        }

        .download-pdf-btn:hover {
          background: #64192e;
          color: white;
          border: 1px solid var(--primary);
        }

        @media (max-width: 1200px) {
          .layout {
            grid-template-columns: 1fr;
          }

          .filter-container {
            position: static;
          }
        }

        @media (max-width: 900px) {
          .modal-content {
            grid-template-columns: 1fr;
          }

          .modal-price-section {
            position: static;
          }
        }

        @media (max-width: 768px) {
          .testimonial-wrapper {
            flex-direction: column;
          }

          .cards {
            grid-template-columns: 1fr;
          }

          .title {
            font-size: 2rem;
          }
        }

        @media (max-width: 600px) {
          .modal-overlay {
            padding: 1rem;
          }

          .modal-header,
          .modal-image-gallery,
          .modal-content {
            padding: 1rem;
          }

          .main-image {
            height: 250px;
          }

          .thumbnail-container {
            grid-template-columns: repeat(2, 1fr);
          }

          .form-row {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .search-box button {
            padding: 0 1.5rem;
          }

          .card-footer {
            flex-direction: column;
          }

          .load-buttons {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>

      <div className="container">
        <h1 className="title">Domestic Tour Packages</h1>
        <p className="subtitle">
          Discover handcrafted tour packages to the world's most enchanting
          destinations, carefully designed for unforgettable experiences
        </p>

        <div className="search-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search packages by title, destination, or highlights..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button onClick={() => setSearchQuery(searchQuery)}>
              <i className="fas fa-search"></i> Search
            </button>
          </div>
        </div>

        <div className="layout">
          <div className="filter-container">
            <div className="filter-box">
              <div className="filter-header">
                <span>Price Range</span>
                <i className="fas fa-sliders-h"></i>
              </div>
              <div className="slider-labels">
                <span>₹{priceRange[0].toLocaleString()}</span>
                <span>₹{priceRange[1].toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="150000"
                step="1000"
                value={priceRange[0]}
                onChange={(e) =>
                  setPriceRange([+e.target.value, priceRange[1]])
                }
                className="range-slider"
              />
              <input
                type="range"
                min="0"
                max="150000"
                step="1000"
                value={priceRange[1]}
                onChange={(e) =>
                  setPriceRange([priceRange[0], +e.target.value])
                }
                className="range-slider"
              />
              <div className="price-inputs">
                <input
                  type="number"
                  value={priceRange[0]}
                  onChange={(e) =>
                    setPriceRange([+e.target.value, priceRange[1]])
                  }
                  placeholder="Min Price"
                  min="0"
                />
                <input
                  type="number"
                  value={priceRange[1]}
                  onChange={(e) =>
                    setPriceRange([priceRange[0], +e.target.value])
                  }
                  placeholder="Max Price"
                  max="150000"
                />
              </div>
              <div className="buttons">
                <button className="clear-btn" onClick={resetFilters}>
                  Reset
                </button>
                <button className="apply-btn">Apply Filters</button>
              </div>
            </div>

            <div className="filter-box">
              <div
                className={`filter-header ${
                  !showDestinations ? "collapsed" : ""
                }`}
                onClick={() => setShowDestinations(!showDestinations)}
              >
                <span>Destinations</span>
                <i className="fas fa-chevron-down"></i>
              </div>
              {showDestinations && (
                <div className="checkboxes scrollable">
                  {destinations.map((dest) => (
                    <div key={dest} className="checkbox-item">
                      <input
                        type="checkbox"
                        id={`dest-${dest}`}
                        checked={selectedDestinations.includes(dest)}
                        onChange={() => handleDestinationChange(dest)}
                      />
                      <label htmlFor={`dest-${dest}`}>{dest}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="filter-box">
              <div
                className={`filter-header ${!showFlights ? "collapsed" : ""}`}
                onClick={() => setShowFlights(!showFlights)}
              >
                <span>Trip Type</span>
                <i className="fas fa-chevron-down"></i>
              </div>
              {showFlights && (
                <div className="checkboxes">
                  <div className="checkbox-item">
                    <input type="checkbox" id="with-flight" />
                    <label htmlFor="with-flight">With Flight</label>
                  </div>
                  <div className="checkbox-item">
                    <input type="checkbox" id="without-flight" />
                    <label htmlFor="without-flight">Without Flight</label>
                  </div>
                  <div className="checkbox-item">
                    <input type="checkbox" id="customizable" />
                    <label htmlFor="customizable">Customizable</label>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="cards-container">
            {loading ? (
              <div className="loading-container">
                <div className="spinner"></div>
              </div>
            ) : filteredPackages.length > 0 ? (
              <>
                <div className="cards">
                  {displayedPackages.map((tour) => (
                    <TourCard 
                      key={tour.id} 
                      tour={tour} 
                      onClick={() => setSelectedTour(tour)}
                    />
                  ))}
                </div>

                <div className="load-buttons">
                  {visibleCount < filteredPackages.length && (
                    <button
                      className="load-more-btn"
                      onClick={loadMorePackages}
                    >
                      Load More <i className="fas fa-plus"></i>
                    </button>
                  )}
                  {visibleCount > 3 && (
                    <button
                      className="show-less-btn"
                      onClick={showLessPackages}
                    >
                      Show Less <i className="fas fa-minus"></i>
                    </button>
                  )}
                </div>
              </>
            ) : (
              <div className="no-results">
                <i
                  className="fas fa-compass fa-3x"
                  style={{ marginBottom: "20px", color: "#bdc3c7" }}
                ></i>
                <h3>No packages match your filters</h3>
                <p>Try adjusting your search criteria or reset the filters</p>
                <button
                  className="load-more-btn"
                  onClick={resetFilters}
                  style={{ marginTop: "20px" }}
                >
                  Reset Filters
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="tour-container">
          <h1>Book Your Perfect Domestic Tour Packages with Pearl</h1>
          <p>
            Pearl Tours and Travels, located at Shop No. 6 in Pearl Enclave on
            MSEB Road, Vishrambag, Sangli, Maharashtra PIN- 416416, offers a
            range of travel services including domestic and international tour
            packages, flight and hotel bookings, family/group travel, adventure,
            honeymoon, visa support, and travel insurance. With a focus on
            customized itineraries and customer support, they position
            themselves as a trusted local partner for hassle-free travel
            planning Though not widely covered in independent reviews, they
            appear alongside other Sangli travel agents in business listings,
            which suggests local recognition and established presence
          </p>

          <h2>Popular Destinations For Domestic Holiday Packages</h2>
          <p>
            Pearl Tours and Travels, Sangli specializes in customized domestic
            tour packages across India's most captivating destinations. Whether
            it's the snow-capped beauty of Shimla-Manali and Kashmir, the serene
            backwaters of Kerala, the royal heritage of Rajasthan, or the scenic
            charm of Sikkim and Darjeeling, Pearl Tours offers well-planned and
            comfortable travel experiences. They also organize relaxing getaways
            to Mysore-Ooty, ensuring hassle-free services including transport,
            accommodation, and local sightseeing—making every journey smooth,
            enjoyable, and unforgettable.
          </p>

          <h2>Book Domestic Tour Packages with Pearl Tours</h2>
          <p>
            Domestic tours may seem a bit complicated. But it is not the
            case when you buy Pearl's Domestic tour packages. We make
            everything easier, simpler, and more comfortable. We have numerous
            domestic tour packages that are handcrafted according to your travel
            taste. If you are traveling with family, we have several
            Domestic tour packages for family. However, if you are planning
            a honeymoon, we have various Domestic tour packages for
            couples. This is how we put your travel needs first every step of
            the way.
          </p>
        </div>

        <div className="testimonial-wrapper">
          <div className="testimonial-content">
            <p className="section-label">Testimonials</p>
            <h2>Delighted Travelers</h2>
            <div className="stars">★★★★★</div>
            <p className="testimonial-text">
              "Our trip with Pearl Tours was just fantastic. We learnt
              about different cultures and traditions across India. We have also tried delicious
              food and indulged in different adventures…"
            </p>
            <p className="author">Dr. Ramesh Keval Chand</p>
          </div>

          <div className="testimonial-images">
            <img
              src={testominialBG}
              alt="Indian Culture"
              className="img-left"
            />
          </div>
        </div>
      </div>

      {selectedTour && (
        <TourDetailsModal
          tour={selectedTour}
          onClose={() => setSelectedTour(null)}
        />
      )}

      <Footer />
    </>
  );
}